import { css } from '@emotion/react'
import { Link } from 'gatsby'
import { BreadcrumbJsonLd, BreadcrumbJsonLdProps } from 'gatsby-plugin-next-seo'
import React from 'react'
import { PathProps } from '../../../paths-config'
import { rem } from '../../styles/mixin.styles'
import { breakpoints, colors, fontSize, space } from '../../styles/variables.styles'

import { generatePath, getPathName } from '../../utils/customPath'

type BreadcrumbProps = {
  slug: PathProps['slug']
  childPage?: ChildPage
}

export type ChildPage = {
  slug: string
  title: string
  pageId: string
}

/**
 * Breadcrumb
 *
 * Display breadcrumb list up to 3 levels
 *
 * @param BreadcrumbProps breadcrumb props
 * @returns breadcrumb and breadcrumb JSON-LD
 */
export const Breadcrumb = ({ slug, childPage }: BreadcrumbProps) => {
  const SecoundPageName = getPathName(slug)

  const JsonLdItems: BreadcrumbJsonLdProps['itemListElements'] = [
    {
      position: 1,
      name: getPathName(''),
      item: generatePath('', 0, '', true)
    },
    {
      position: 2,
      name: SecoundPageName,
      item: generatePath(slug, 0, '', true)
    }
  ]
  if (childPage) {
    JsonLdItems.push({
      position: 3,
      name: childPage.title,
      item: generatePath(childPage.slug, 0, childPage.pageId, true)
    })
  }

  return (
    <>
      <BreadcrumbJsonLd itemListElements={JsonLdItems} />
      <div css={breadcrumbAreaStyles}>
        <ul className="breadcrumb">
          <li className="breadcrumb__item">
            <Link to={generatePath('')}>{getPathName('')}</Link>
          </li>
          <li className="breadcrumb__item">
            {childPage ? <Link to={generatePath(slug)}>{SecoundPageName}</Link> : <>{SecoundPageName}</>}
          </li>
          {childPage && <li className="breadcrumb__item">{childPage.title}</li>}
        </ul>
      </div>
    </>
  )
}

const breadcrumbAreaStyles = css`
  background-color: ${colors.bgGray.hex};
  width: 100%;
  .breadcrumb {
    width: min(calc(100% - ${space.md} * 2), ${breakpoints.lg}px);
    display: flex;
    margin: 0 auto;
    padding: ${rem(9)} 0;
    .breadcrumb__item {
      font-size: ${fontSize.sm};
      list-style: none;
      &:not(:first-of-type)::before {
        content: '/';
        padding-left: 1em;
        padding-right: 1em;
      }
      > a {
        color: ${colors.mainBlue.hex};
      }
    }
  }
`
